'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$71() {
  this.bmt = null;
  this.bmu = false;
}
export { $c_Lpresto_PrestoRouter$$anon$71 as $c_Lpresto_PrestoRouter$$anon$71 };
$p = $c_Lpresto_PrestoRouter$$anon$71.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$71;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$71() {
}
export { $h_Lpresto_PrestoRouter$$anon$71 as $h_Lpresto_PrestoRouter$$anon$71 };
$h_Lpresto_PrestoRouter$$anon$71.prototype = $p;
$p.bW = (function() {
  if ((!this.bmu)) {
    this.bmt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bmu = true;
  }
  return this.bmt;
});
$p.P = (function() {
  return this.bW();
});
var $d_Lpresto_PrestoRouter$$anon$71 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$71, "presto.PrestoRouter$$anon$71", ({
  OE: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$71 as $d_Lpresto_PrestoRouter$$anon$71 };
//# sourceMappingURL=presto.-Presto-Router$$anon$71.js.map
